import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import { Table } from "../Table";
import handleSearch from "../../utils/handleSearch";
import { Modal } from "../Modal";
import { getStorage } from "../../utils/storage";
import toastMessage from "../../utils/toastMessage";
import axios from "axios";
import { fetchBoardMember } from "../../queries/boardMember/boardMemberQuery";
import NewBoardMember from "./NewBoardMember";

let copyData = [];

class ListBoardMembers extends React.Component {
  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 1,
    search_text: "",
    selected_data: {},
    error: {},
    csvData: [],
    delete_password: "",
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    this.getData(true);
  };

  getData = async (isLoading) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoading });

      const data = await fetchBoardMember(defaultLanguage);

      this.setState({
        isLoading: false,
        data: data,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e.target.value,
      error,
    });
  }

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].name,
        key: "name",
      },
      {
        title:
          language[this.props.defaultLanguage].national_identification_number,
        key: "nationalIdentificationNumber",
      },
      {
        title: language[this.props.defaultLanguage].email_address,
        key: "email",
      },
      {
        title: language[this.props.defaultLanguage].phone_number,
        key: "phoneNumber",
      },
      {
        title: language[this.props.defaultLanguage].attachment,
        key: "phoneNumber",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers;
  }

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          isSearch={this.props.showSearch}
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          handleSearch={(e) =>
            handleSearch(this, {
              copyData,
              value: e.target.value,
            })
          }
          showAdd={this.props.showAdd}
          addButtonText={language[this.props.defaultLanguage].add_board_member}
          totalPageCount={this.state.totalPageCount}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          handleAddPressed={this.handleShowModal.bind(
            this,
            "showModal",
            language[this.props.defaultLanguage].board_member
          )}
          actions={[
            {
              name: language[this.props.defaultLanguage].edit,
              onPress: (item) => this.handleShowModal("showModal", "", item),
            },
          ]}
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          <NewBoardMember
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selected_data}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ListBoardMembers);
